<script>
import { mapState } from 'vuex'
import {get} from 'lodash'

export default {
  name: 'EditStaffModal',
  data () {
    return {
      formLayout: 'horizontal',
      visible: true,
      form: null,
    }
  },
  computed: {
    ...mapState({
      editingAgent: state => state.staff.editingAgent,
      isLoading: state => state.staff.isLoading,
      error: state => state.staff.error,
    }),
  },
  watch: {
    visible (newValue) {
      if (!newValue) {
        this.$store.commit('staff/setEditingAgent', null)
      }
    },
    editingAgent (newValues) {
      this.form = this.$form.createForm(this, {
        onFieldsChange: (_, changedFields) => {
          this.$emit('change', changedFields)
        },
        mapPropsToFields: () => {
          return {
            email: this.$form.createFormField({
              value: get(newValues, 'email', ''),
            }),
            name: this.$form.createFormField({
              value: get(newValues, 'name', ''),
            }),
            roles: this.$form.createFormField({
              value: (newValues && newValues.roles && this.editingAgent.roles[0]) || 'support',
            }),
            active: this.$form.createFormField({
              value: get(newValues, 'active', true),
            }),
            password: this.$form.createFormField({
              value: '',
            }),
          }
        },
        onValuesChange: (_, values) => {
          for (let field in values) {
            if (!values.hasOwnProperty(field)) {
              continue
            }

            this.$store.commit('staff/onFieldChange', {field, value: values[field]})
          }
        },
      })
    }
  },
  created () {

  },
  methods: {
    validateBeforeSubmit () {
      this.form.validateFields((err, values) => {
        console.log('bubmit')
        if (!err) {
          this.$store.dispatch('staff/saveAgent')
        }
      })
    },
    handleCancel () {
      this.$store.commit('staff/setEditingAgent', null)
    },
    handleOk () {
      this.form.validateFields((err, values) => {
        console.log('bubmit', err)
        if (!err) {
          this.$store.dispatch('staff/saveAgent')
        }
      })
    },
    onFieldChange (field, value) {
      const newVal = {}
      newVal[field] = value
      this.form.setFieldsValue(newVal)
    },
    getPasswordDecorator () {
      if (!this.editingAgent || !this.editingAgent.id) {
        return [
          'password',
          {rules: [{required: true, message: 'Please input password'}]}
        ]
      }
      return [
        'password',
      ]
    }
  },
}
</script>

<template>
  <a-modal
          v-if="editingAgent"
          :visible="!!editingAgent"
          title="Manage Staff"
          onOk="handleOk"
          style="width: 70%;"
  >
    <template slot="footer">
      <a-button key="submit"
                type="primary"
                :disabled="isLoading"
                @click="handleOk"
      >
        <span v-if="editingAgent.id">Save</span>
        <span v-else>Add</span>
      </a-button>
      <a-button
              key="back"
              @click="handleCancel">
        Cancel
      </a-button>
    </template>
    <div>
      <a-form @submit.prevent="validateBeforeSubmit" :form="form">
        <a-form-item label="Staff Email"
                     :label-col="{ span: 6 }"
                     :wrapper-col="{ span: 12 }">
          <a-input placeholder="Staff Email"
                   v-decorator="[
                    'email',
                    {rules: [{required: true, message: 'Please input email', type: 'email'}]}
                   ]"
                   html-type="text"
          />
        </a-form-item>

        <a-form-item label="Staff Name"
                     :label-col="{ span: 6 }"
                     :wrapper-col="{ span: 12 }">
          <a-input placeholder="Staff Name"
                   v-decorator="[
                    'name',
                    {rules: [{required: true, message: 'Please input name'}]}
                   ]"
                   html-type="text"/>
        </a-form-item>

        <a-form-item label="Role"
                     :label-col="{ span: 6 }"
                     :wrapper-col="{ span: 12 }">
          <a-select
            v-decorator="[
                'roles',
                {rules: [{required: true, message: 'Please select a role'}]}
               ]">
            <a-select-option value="admin">Admin</a-select-option>
            <a-select-option value="support">Support</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="Password"
                     :label-col="{ span: 6 }"
                     :wrapper-col="{ span: 12 }">
          <a-input placeholder="password"
                   v-decorator="getPasswordDecorator()"
                   name="password"
                   type="password"
          />
        </a-form-item>

        <a-form-item label="Active"
                     :label-col="{ span: 6 }"
                     :wrapper-col="{ span: 12 }">
          <a-checkbox
                  v-decorator="['active']"
                  :checked="editingAgent.active"
                  :value="!editingAgent.active"
          >
          </a-checkbox>
        </a-form-item>

        <p style="color: red" v-if="error">{{ error }}</p>
      </a-form>
    </div>
  </a-modal>
</template>



// WEBPACK FOOTER //
// src/components/Staff/EditStaffModal.vue